import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
  DataContext.register([
    {
      name: "DEVICE_STOP_KEY",
      data: DEVICE_STOP_KEY
    },
    {
      name: "DEVICE_STOP_HISTORY",
      data: DEVICE_STOP_HISTORY
    },
    {
      name: "STOP_REASON_PERCENTAGE",
      data: STOP_REASON_PERCENTAGE
    },
    {
      name: "STOP_RUN_BAR",
      data: STOP_RUN_BAR
    },
    {
      name: "STOP_RUN_BAR_OVERVIEW",
      data: STOP_RUN_BAR_OVERVIEW
    }
  ]);
}


const DEVICE_STOP_KEY = [  //设备详情(停机)的关键数据项
  {
    duration: "33:05",//停机时长
    frequency: 38, //停机次数
    maxDuration: "2:05", //停机 最大持续时间
    timeUtilization: "95%", //时间利用率
    downtimePerMillion: "33", //每百万支停机数
    shiftPercentage: "56%",//停机 班次时间占比
  },
  {
    duration: "28:45",//停机时长
    frequency: 43, //停机次数
    maxDuration: "3:45", //停机 最大持续时间
    timeUtilization: "91%", //时间利用率
    downtimePerMillion: "44", //每百万支停机数
    shiftPercentage: "61%",//停机 班次时间占比
  },
  {
    duration: "43:55",//停机时长
    frequency: 56, //停机次数
    maxDuration: "4:15", //停机 最大持续时间
    timeUtilization: "92%", //时间利用率
    downtimePerMillion: "55", //每百万支停机数
    shiftPercentage: "64%",//停机 班次时间占比
  }
];

const DEVICE_STOP_HISTORY = [
  [
    { type: "跑条", value: [[3.1, 3.2], [3.5, 3.6], [4.45, 5], [6.1, 6.2], [6.3, 6.45], [6.48, 6.5], [6.52, 6.55], [6.6, 6.7]], color: theme.color.danger },
    { type: "甘油故障", value: [[2.1, 2.2], [3.2, 3.3], [3.45, 3.48], [4.1, 4.15], [4.5, 4.56], [4.7, 4.72], [4.75, 4.78], [5.2, 5.25]], color: theme.color.pink },
    { type: "断纸", value: [[5.1, 5.2], [5.25, 5.28], [5.3, 5.35], [6, 6.15], [6.3, 6.4], [6.43, 6.46], [6.53, 6.55], [6.6, 6.65]], color: theme.color['m-primary'] },
    { type: "清洁保养", value: [[4.5, 4.55], [4.6, 4.75], [5.1, 5.2], [6.05, 6.35], [6.45, 6.5], [6.55, 6.58], [6.6, 6.62], [6.65, 6.7]], color: theme.color['r-green'] },
    { type: "质量问题", value: [[4.1, 4.23], [4.6, 4.71], [5, 5.2], [6.15, 6.25], [6.35, 6.5], [6.52, 6.55], [6.58, 6.6], [6.62, 6.7]], color: theme.color.info },
    { type: "操作停机", value: [[3.5, 3.6], [3.5, 3.6], [4.45, 5], [6.1, 6.2], [6.3, 6.45], [6.48, 6.5], [6.52, 6.55], [6.6, 6.7]], color: theme.color.warning }
  ],
  [
    { type: "跑条", value: [[3.5, 3.6], [3.5, 3.6], [4.45, 5], [6.1, 6.2], [6.3, 6.45], [6.48, 6.5], [6.52, 6.55], [6.6, 6.7]], color: theme.color.danger },
    { type: "甘油故障", value: [[4.1, 4.23], [4.6, 4.71], [5, 5.2], [6.15, 6.25], [6.35, 6.5], [6.52, 6.55], [6.58, 6.6], [6.62, 6.7]], color: theme.color.pink },
    { type: "断纸", value: [[4.5, 4.55], [4.6, 4.75], [5.1, 5.2], [6.05, 6.35], [6.45, 6.5], [6.55, 6.58], [6.6, 6.62], [6.65, 6.7]], color: theme.color['m-primary'] },
    { type: "清洁保养", value: [[5.1, 5.2], [5.25, 5.28], [5.3, 5.35], [6, 6.15], [6.3, 6.4], [6.43, 6.46], [6.53, 6.55], [6.6, 6.65]], color: theme.color['r-green'] },
    { type: "质量问题", value: [[2.1, 2.2], [3.2, 3.3], [3.45, 3.48], [4.1, 4.15], [4.5, 4.56], [4.7, 4.72], [4.75, 4.78], [5.2, 5.25]], color: theme.color.info },
    { type: "操作停机", value: [[3.1, 3.2], [3.5, 3.6], [4.45, 5], [6.1, 6.2], [6.3, 6.45], [6.48, 6.5], [6.52, 6.55], [6.6, 6.7]], color: theme.color.warning }
  ],
  [
    { type: "跑条", value: [[5.1, 5.2], [5.25, 5.28], [5.3, 5.35], [6, 6.15], [6.3, 6.4], [6.43, 6.46], [6.53, 6.55], [6.6, 6.65]], color: theme.color.danger },
    { type: "甘油故障", value: [[2.1, 2.2], [3.2, 3.3], [3.45, 3.48], [4.1, 4.15], [4.5, 4.56], [4.7, 4.72], [4.75, 4.78], [5.2, 5.25]], color: theme.color.pink },
    { type: "断纸", value: [[3.1, 3.2], [3.5, 3.6], [4.45, 5], [6.1, 6.2], [6.3, 6.45], [6.48, 6.5], [6.52, 6.55], [6.6, 6.7]], color: theme.color['m-primary'] },
    { type: "清洁保养", value: [[4.5, 4.55], [4.6, 4.75], [5.1, 5.2], [6.05, 6.35], [6.45, 6.5], [6.55, 6.58], [6.6, 6.62], [6.65, 6.7]], color: theme.color['r-green'] },
    { type: "质量问题", value: [[4.1, 4.23], [4.6, 4.71], [5, 5.2], [6.15, 6.25], [6.35, 6.5], [6.52, 6.55], [6.58, 6.6], [6.62, 6.7]], color: theme.color.info },
    { type: "操作停机", value: [[5.1, 5.2], [5.25, 5.28], [5.3, 5.35], [6, 6.15], [6.3, 6.4], [6.43, 6.46], [6.53, 6.55], [6.6, 6.65]], color: theme.color.warning }
  ]
];

const STOP_REASON_PERCENTAGE = [
  [
    { name: "跑条", value: "0.12", color: theme.color.blue, type: 2 },
    { name: "甘油故障", value: "0.07", color: theme.color.warning, type: 2 },
    { name: "断纸", value: "0.03", color: theme.color.green, type: 2 },
    { name: "清洁保养", value: "0.09", color: theme.color.gray, type: 2 },
    { name: "质量问题停机", value: "0.06", color: theme.color.danger, type: 2 },
    { name: "操作停机", value: "0.18", color: theme.color.cyan, type: 2 },
    { name: "正常停机", value: "0.45", color: theme.color.indigo, type: 1 }
  ],
  [
    { name: "跑条", value: "0.14", color: theme.color.blue, type: 2 },
    { name: "甘油故障", value: "0.03", color: theme.color.warning, type: 2 },
    { name: "断纸", value: "0.06", color: theme.color.green, type: 2 },
    { name: "清洁保养", value: "0.07", color: theme.color.gray, type: 2 },
    { name: "质量问题停机", value: "0.01", color: theme.color.danger, type: 2 },
    { name: "操作停机", value: "0.14", color: theme.color.cyan, type: 2 },
    { name: "正常停机", value: "0.55", color: theme.color.indigo, type: 1 }
  ],
  [
    { name: "跑条", value: "0.15", color: theme.color.blue, type: 2 },
    { name: "甘油故障", value: "0.07", color: theme.color.warning, type: 2 },
    { name: "断纸", value: "0.05", color: theme.color.green, type: 2 },
    { name: "清洁保养", value: "0.05", color: theme.color.gray, type: 2 },
    { name: "质量问题停机", value: "0.05", color: theme.color.danger, type: 2 },
    { name: "操作停机", value: "0.12", color: theme.color.cyan, type: 2 },
    { name: "正常停机", value: "0.51", color: theme.color.indigo, type: 1 }
  ]
];

const STOP_RUN_BAR = [
  [42, 44, 39, 45, 46],
  [43, 45, 38, 43, 50],
  [45, 40, 43, 47, 45],
  [45, 42, 46, 44, 50],
];

const STOP_RUN_BAR_OVERVIEW = [
  {
    output: 4357000,
    stopCount: 28,
    stopDuration: "02:09:03",
    runBarCount: 19,
    runBarDuration: "01:05:22",
    runBarMio: 41.58
  },
  {
    output: 4257235,
    stopCount: 22,
    stopDuration: "02:05:55",
    runBarCount: 17,
    runBarDuration: "01:25:36",
    runBarMio: 39.26
  },
  {
    output: 4345200,
    stopCount: 36,
    stopDuration: "03:22:00",
    runBarCount: 25,
    runBarDuration: "02:15:35",
    runBarMio: 55.72
  }
];